module.exports = "https://static.zego.com/_next/static/images/TickNoCircle-71ca14e346d868f6d0eaa48b19c12d94.svg";